import React, { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../context/UserContext";
import { AuthContext } from "../context/AuthContext";
import NavSub from "../components/NavSub";
import ToastComponent from "../components/ToastComponent";
import { Select, MenuItem } from "@mui/material";
import "../Styles/Capacity.css";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
} from "../utils/GetUrl";
import * as XLSX from 'xlsx';

import { CircularProgress } from "@mui/material";
const Capacity2 = () => {
  const { usersList, teamNames } = useContext(UserContext);
  const { token, userData, logout } = useContext(AuthContext);
  const toastRef = useRef();
  const [budgetData, setBudgetData] = useState([]);
  const [budgetPrevYear, setBudgetPrevYear] = useState([]);
  const [budgetNextYear, setBudgetNextYear] = useState([]);
  const [capl, setCapl] = useState(false);
  const [capl2, setCapl2] = useState(false);
  const [budl, setBudl] = useState(false);
  const [loading, setLoading] = useState(false);
  const [capacityData, setCapacityData] = useState([]);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1; // If Jan, go to Dec
  const twoMonthsAgo =
    currentMonth <= 2 ? 12 + (currentMonth - 2) : currentMonth - 2; // Two months before current month
  const getCapacityByUserAndMonth = (user, monthNumber) => {
    const userCapacity = capacityData.find(
      (data) =>
        data.AssginedTo === user.EM_ID &&
        parseInt(data.CreatedMonth) === monthNumber
    );
    return userCapacity ? parseInt(userCapacity.TotalTime) || 0 : 0;
  };

  const calculateTotalCapacity = (user) => {
    const months = Array.from({ length: 12 }, (_, index) => index + 1); // [1, 2, ..., 12]
    return months.reduce(
      (total, monthNumber) =>
        total + getCapacityByUserAndMonth(user, monthNumber),
      0
    );
  };

  // const getYTDForUser = (user) => {
  //   const userBudget = budgetData.find((data) => data.empid === user.EM_EmpID);
  //   return userBudget ? parseInt(userBudget.ytd) || 0 : 0;
  // };
  const getYTDForUser = (user) => {
    const userBudget = budgetData.find((data) => data.empid === user.EM_EmpID);
    if (!userBudget) return 0;
    const currentMonth = new Date().getMonth() + 1;
    let ytdValue = 0;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Decs"];
    for (let month = 1; month <= currentMonth; month++) {
      const monthName = monthNames[month - 1];
      ytdValue += parseFloat(userBudget[monthName]) || 0;
    }
    return ytdValue;
  };

  const getMTDForUser = (user) => {
    return getCapacityByUserAndMonth(user, previousMonth);
  };

  const getBudgetedMtdForUser = (user) => {
    const currentMonth = new Date().getMonth();
    const previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Decs"];
    const previousMonthName = monthNames[previousMonth];
    const budgetDataForUser = budgetData.find((data) => data.empid === user.EM_EmpID);
    return budgetDataForUser ? parseFloat(budgetDataForUser[previousMonthName]) || 0 : 0;
  };

  const getForecastMtdForUser = (user, month) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Decs"];
    const monthName = month === "Dec" ? "Decs" : month;
    const monthIndex = monthNames.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
    if (monthIndex < 0) return 0;
    const userBudget = budgetData.find((data) => data.empid === user.EM_EmpID);
    if (!userBudget) return 0;
    const budgetForMonth = parseFloat(userBudget[monthNames[monthIndex]]) || 0;
    const actualHoursForMonth = (parseFloat(getCapacityByUserAndMonth(user, monthIndex + 1)) || 0) / 60;
    return budgetForMonth - actualHoursForMonth;
  };
  
  
  
  
  

  function getNextSixMonths() {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Decs",
    ];
    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth(); // 0 (Jan) to 11 (Dec)
    const nextSixMonths = [];
    for (let i = 0; i < 6; i++) {
      const monthIndex = (currentMonthIndex + i) % 12;
      nextSixMonths.push(monthNames[monthIndex]);
    }
    return nextSixMonths;
  }
  const nextSixMonths = getNextSixMonths();
  const tableStyle = {
    borderCollapse: "collapse",
    // width: '100%',
    marginTop: "20px",
    marginBottom: "20px",
    // width: "fit-content",
  };

  const thTdStyle = {
    padding: "20px",
    backgroundColor: "white",
    textAlign: "center",
    // width: "fit-content",
  };
  const firstThStyle = {
    ...thTdStyle,
    borderTopLeftRadius: "10px",
  };

  const lastThStyle = {
    ...thTdStyle,
    borderTopRightRadius: "10px",
  };

  const thTdLeftAlignStyle = {
    ...thTdStyle,
    textAlign: "left",
  };

  const trStyle = {
    borderTop: "1px solid #ddd",
    padding: "20px",
  };

  const tdPaddingStyle = {
    padding: "20px",
    textAlign: "center",
    borderRight: "1px solid #D9D9D9",
    minWidth: "105px",
    maxWidth:'105px',
    overflow:'scroll'
  };

  // ////////////////////////////////////////////////////
  const [selectedYear, setSelectedYear] = useState("");
  const years = Array.from({ length: 12 }, (_, index) => 2020 + index);
  const currentYear = new Date().getFullYear();
  if (!years.includes(currentYear)) {
    years.push(currentYear);
    years.sort((a, b) => a - b);
  }

  useEffect(() => {
    setSelectedYear((prevYear) => prevYear || currentYear);
  }, []);
  const handleChange = (event) => {
    setSelectedYear(event.target.value);
  };


// const currentYear = new Date().getFullYear().toString();


  // ////////////////////////////////////////

  const fetchBudgetData = async () => {
    if (!token){
      return;
    }
    setBudl(true);
    try {
      const response = await fetch(
        `${userApiUrl}/GetLatestBudget?Year=${selectedYear}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (!response.ok) {
        throw new Error(
          `Failed to fetch budget data. Status: ${response.status}`
        );
      }

      const data = await response.json();
      setBudgetData(data);
      setBudgetNextYear(data);
      setBudl(false);

    } catch (error) {
      setBudl(false);

      console.error("Error fetching budget data:", error);
    }
  };

  const fetchPrevBudgetData = async () => {
    if(!token){
      return;
    }
    setCapl2(true);
    try {
      const response = await fetch(
        `${userApiUrl}/GetLatestBudget?Year=${selectedYear}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (!response.ok) {
        throw new Error(
          `Failed to fetch budget data. Status: ${response.status}`
        );
      }
      const data = await response.json();
      setBudgetPrevYear(data);
      setCapl2(false);

    } catch (error) {
      setCapl2(false);
      console.error("Error fetching budget data:", error);
    }
  };

  const fetchData = async () => {
    if(!token) {
      return;
    }
    setCapl(true);

    try {

      const url = `${taskApiUrl}/GetCapacityUtilisation?CreatedYear=${selectedYear}`;
      const response = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setCapacityData(data);
      setCapl(false);
    } catch (error) {
      setCapl(false);

      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedYear && token) { 
      fetchBudgetData();
      fetchPrevBudgetData();
      fetchData();
    }
  }, [selectedYear, token]);

  useEffect(()=>{
    if(capl==false&&capl2==false&&budl==false){
      setLoading(false)
    }else{
      setLoading(true);
    }
  },[capl,capl2,budl])

  const [selectedTeam, setSelectedTeam] = useState(null);
  const teams = teamNames.filter(
    (team) =>
      team.superTeamId === 0 && team?.status == true && team?.type == "T"
  );
  const subteams = selectedTeam
    ? teamNames.filter(
        (team) => team.superTeamId === selectedTeam && team?.status == true
      )
    : teamNames.filter(
        (team) => team.superTeamId !== 0 && team?.status == true
      );
  const handleTeamChange = (event) => {
    setSelectedTeam(event.target.value ? Number(event.target.value) : null);
  };
  const calculateSubteamTotals = (subteamId) => {
    const filteredUsers = usersList.filter(
      (user) => Number(user.STM_Subteam) === subteamId
    );

    // Initialize totals object
    const totals = {
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      oct: 0,
      nov: 0,
      dec: 0,
      actualHoursYTD: 0,
      budgetHoursYTD: 0,
      utilizationYTD: 0,
      actualHoursMTD: 0,
      budgetHoursMTD: 0,
      utilizationMTD: 0,
    };

    filteredUsers.forEach((user) => {
      // Accumulate monthly capacities
      for (let month = 1; month <= 12; month++) {
        const monthName = new Date(0, month - 1)
          .toLocaleString("default", { month: "short" })
          .toLowerCase();
        totals[monthName] += getCapacityByUserAndMonth(user, month);
      }

      // Accumulate YTD and MTD values
      totals.actualHoursYTD += calculateTotalCapacity(user);
      totals.budgetHoursYTD += getYTDForUser(user);
      totals.actualHoursMTD += getMTDForUser(user);
      totals.budgetHoursMTD += getBudgetedMtdForUser(user);
    });

    // Calculate utilization
    totals.utilizationYTD =
      totals.budgetHoursYTD > 0
        ? ((totals.actualHoursYTD / totals.budgetHoursYTD) * 100).toFixed(0)
        : 0;
    totals.utilizationMTD =
      totals.budgetHoursMTD > 0
        ? ((totals.actualHoursMTD / totals.budgetHoursMTD) * 100).toFixed(0)
        : 0;

    return totals;
  };
  const [subteamTotals, setSubteamTotals] = useState({
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
    actualHoursYTD: 0,
    budgetHoursYTD: 0,
    utilizationYTD: 0,
    actualHoursMTD: 0,
    budgetHoursMTD: 0,
    utilizationMTD: 0,
  });

  useEffect(() => {
    if (selectedTeam) {
      setSubteamTotals(calculateSubteamTotals(selectedTeam));
    }
  }, [selectedTeam, usersList, capacityData, budgetData]);
  const totalRowStyle = {
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
  };

  const totalCellStyle = {
    padding: "20px",
    textAlign: "right",
    borderRight: "1px solid #D9D9D9",
    width: "100px",
  };


function exportToExcel(subteams, usersList, nextSixMonths, teamNames) {
  // return;
  const workbook = XLSX.utils.book_new();

  subteams.forEach((subteam) => {
    const sheetData = [];
    
    // Header Row 1
    const headerRow1 = [
      "", "", "", "", "", "", "", "", "", "", "", "", "", "", 
      "YTD Hours", "", "", 
      "MTD Hours", "", "", 
      "Forecast Capacity for Next 6 Months"
    ];
    nextSixMonths.forEach(() => headerRow1.push(""));
    sheetData.push(headerRow1);

    // Header Row 2
    const headerRow2 = [
      "Name", "Team", "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", 
      "Actual Hours YTD", "Budget Hours YTD", "Utilization YTD",
      "Actual Hours MTD", "Budget Hours MTD", "Utilization MTD"
    ];
    nextSixMonths.forEach((month) => headerRow2.push(month === "Decs" ? "Dec" : month));
    sheetData.push(headerRow2);

    // Data Rows
    usersList
      .filter((user) => Number(user.STM_Subteam) === subteam.id)
      .forEach((user, index) => {
        const resolvedTeamName = teamNames.find(
          (team) => team?.id === parseFloat(user?.STM_Team)
        )?.name || "";

        const userRow = [
          `${user.EM_FirstName} ${user.EM_LastName}`,
          resolvedTeamName,
          ...Array.from({ length: 12 }, (_, month) => 
            (getCapacityByUserAndMonth(user, month + 1) / 60).toFixed(2)
          ),
          (calculateTotalCapacity(user) / 60).toFixed(2),
          getYTDForUser(user).toFixed(2),
          getYTDForUser(user) > 0
            ? ((calculateTotalCapacity(user) / getYTDForUser(user)) * (100 / 60)).toFixed(0) + "%"
            : "0%",
          (getMTDForUser(user) / 60).toFixed(2),
          getBudgetedMtdForUser(user).toFixed(2),
          getBudgetedMtdForUser(user) > 0
            ? ((getMTDForUser(user) / getBudgetedMtdForUser(user)) * 100).toFixed(0) + "%"
            : "0%",
          ...nextSixMonths.map((month) => 
            (getForecastMtdForUser(user, month) / 60).toFixed(2)
          )
        ];

        sheetData.push(userRow);
      });

    // Total Row
    const totalRow = [
      "Total", "", 
      ...Array.from({ length: 12 }, (_, month) => {
        const total = usersList
          .filter((user) => Number(user.STM_Subteam) === subteam.id)
          .reduce((sum, user) => sum + getCapacityByUserAndMonth(user, month + 1) / 60, 0);
        return total.toFixed(2);
      }),
      usersList
        .filter((user) => Number(user.STM_Subteam) === subteam.id)
        .reduce((sum, user) => sum + calculateTotalCapacity(user) / 60, 0)
        .toFixed(2),
      usersList
        .filter((user) => Number(user.STM_Subteam) === subteam.id)
        .reduce((sum, user) => sum + getYTDForUser(user), 0)
        .toFixed(2),
      (() => {
        const ytdTotal = usersList
          .filter((user) => Number(user.STM_Subteam) === subteam.id)
          .reduce((sum, user) => sum + calculateTotalCapacity(user) / 60, 0);
        const ytdBudget = usersList
          .filter((user) => Number(user.STM_Subteam) === subteam.id)
          .reduce((sum, user) => sum + getYTDForUser(user), 0);
        return ytdBudget > 0 ? ((ytdTotal / ytdBudget) * 100).toFixed(0) + "%" : "0%";
      })(),
      usersList
        .filter((user) => Number(user.STM_Subteam) === subteam.id)
        .reduce((sum, user) => sum + getMTDForUser(user) / 60, 0)
        .toFixed(2),
      usersList
        .filter((user) => Number(user.STM_Subteam) === subteam.id)
        .reduce((sum, user) => sum + getBudgetedMtdForUser(user), 0)
        .toFixed(2),
      (() => {
        const totalBudgetedMTD = usersList
          .filter((user) => Number(user.STM_Subteam) === subteam.id)
          .reduce((sum, user) => sum + getBudgetedMtdForUser(user), 0);
        const totalMTD = usersList
          .filter((user) => Number(user.STM_Subteam) === subteam.id)
          .reduce((sum, user) => sum + getMTDForUser(user), 0);
        return totalBudgetedMTD > 0 ? ((totalMTD / totalBudgetedMTD) * 100).toFixed(0) + "%" : "0%";
      })(),
      ...nextSixMonths.map((month) => {
        const totalForecast = usersList
          .filter((user) => Number(user.STM_Subteam) === subteam.id)
          .reduce((sum, user) => sum + getForecastMtdForUser(user, month) / 60, 0);
        return totalForecast.toFixed(2);
      })
    ];
    
    sheetData.push(totalRow);

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, subteam.name);
  });

  XLSX.writeFile(workbook, `CapacityReport.xlsx`);
}

// //////////////////////////////////////////////////////////////////

useEffect(() => {
  const tableContainer = document.querySelector(".scroll-utilization");

  if (tableContainer) {
    let isDown = false;
    let startX, startY;
    let scrollLeft, scrollTop;

    const handleMouseDown = (e) => {
      isDown = true;
      tableContainer.classList.add("active");
      startX = e.pageX - tableContainer.offsetLeft;
      startY = e.pageY - tableContainer.offsetTop;
      scrollLeft = tableContainer.scrollLeft;
      scrollTop = tableContainer.scrollTop;
    };

    const handleMouseLeave = () => {
      isDown = false;
      tableContainer.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      tableContainer.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();

      const x = e.pageX - tableContainer.offsetLeft;
      const y = e.pageY - tableContainer.offsetTop;

      const walkX = (x - startX) * 2; // Adjust horizontal speed
      const walkY = (y - startY) * 2; // Adjust vertical speed

      tableContainer.scrollLeft = scrollLeft - walkX;
      tableContainer.scrollTop = scrollTop - walkY;
    };

    tableContainer.addEventListener("mousedown", handleMouseDown);
    tableContainer.addEventListener("mouseleave", handleMouseLeave);
    tableContainer.addEventListener("mouseup", handleMouseUp);
    tableContainer.addEventListener("mousemove", handleMouseMove);

    return () => {
      tableContainer.removeEventListener("mousedown", handleMouseDown);
      tableContainer.removeEventListener("mouseleave", handleMouseLeave);
      tableContainer.removeEventListener("mouseup", handleMouseUp);
      tableContainer.removeEventListener("mousemove", handleMouseMove);
    };
  }
}, []);


  return (
    <div>
      <NavSub />

      <div className="Capacity_layout">
        <ToastComponent ref={toastRef} timeout={4000} />
        <div>
          {loading?(
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <CircularProgress style={{ color: "purple", width:'40px' }}  />
        </div>
      ):
          (<div className="scroll-utilization">
           <div className="Capacity_head">
          

            <div style={{display:'flex',gap:'20px'}}> 

          


          <select style={{fontFamily:'Poppins' }} onChange={handleTeamChange} value={selectedTeam || ""}>
            <option style={{fontFamily:'Poppins'}} value="">All Team</option>
            {teams.map((team) => (
              <option style={{fontFamily:'Poppins'}} key={team.id} value={team.id}>
                {team.name}
              </option>
            ))}
          </select>

          <div className="dropdown-container-g1">
              <Select
                labelId="year-select-label"
                value={selectedYear}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Select Year
                </MenuItem>
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </div>
            </div>

                <div className="Nav-btn-capacity">
                <button className="Nav-Sub-btn-capacity" onClick={()=>{exportToExcel(subteams, usersList, nextSixMonths, teamNames)}}>Export File</button>
                  </div>
           

 

        
        </div>


        
        {subteams.map((subteam) => (
          <>
            <div className="Capacity_head">
              <h1 className="team_name">{subteam.name}</h1>
            </div>
             <div className="table_cap_cont_main" >
 <table style={tableStyle} className="table_cap_cont" >
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th colSpan="3" className="YTD-hours-table-styling ">
                    YTD Hours
                  </th>
                  <th colSpan="3" className="YTD-hours-table-styling">
                    MTD Hours
                  </th>
                  <th
                    colSpan={nextSixMonths.length}
                    className="YTD-hours-table-styling "
                  >
                    Forecast Capacity for Next 6 Months
                  </th>
                </tr>
                <div style={{ margin: "10px" }}></div>
                <tr>
                  <th style={firstThStyle}>Name</th>
                  <th style={{ ...thTdStyle}}>Team</th>
                  <th style={thTdStyle}>Jan</th>
                  <th style={thTdStyle}>Feb</th>
                  <th style={thTdStyle}>Mar</th>
                  <th style={thTdStyle}>Apr</th>
                  <th style={thTdStyle}>May</th>
                  <th style={thTdStyle}>Jun</th>
                  <th style={thTdStyle}>Jul</th>
                  <th style={thTdStyle}>Aug</th>
                  <th style={thTdStyle}>Sep</th>
                  <th style={thTdStyle}>Oct</th>
                  <th style={thTdStyle}>Nov</th>
                  <th style={thTdStyle}>Dec</th>
                  <th style={thTdStyle}>Actual Hours YTD</th>
                  <th style={thTdStyle}>Budget Hours YTD</th>
                  <th style={thTdStyle}>Utilization YTD</th>
                  <th style={thTdStyle}>Actual Hours MTD</th>
                  <th style={thTdStyle}>Budget Hours MTD</th>
                  <th style={thTdStyle}>Utilization MTD</th>
                  {nextSixMonths.map((month) => (
                    <th key={month} style={thTdStyle}>
                      {month==="Decs"?"Dec":month}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {usersList
                  .filter((user) => Number(user.STM_Subteam) === subteam.id)
                  .map((user, index) => {
                    const resolvedTeamName = teamNames?.find(
                      (team) => team?.id === parseFloat(user?.STM_Team)
                    )?.name;

                    return (
                      <tr
                        key={user.EM_ID}
                        style={{
                          ...trStyle,
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "white",
                        }}
                      >
                        <td style={{ ...tdPaddingStyle, textAlign: "left", maxWidth:'200px' }}>
                          {user.EM_FirstName +' '+user.EM_LastName}
                        </td>
                        <td style={{ ...tdPaddingStyle, textAlign: "left",maxWidth:'200px'  }}>
                          {resolvedTeamName}
                        </td>
                        {Array.from(
                          { length: 12 },
                          (_, month) => month + 1
                        ).map((month) => (
                          <td key={month} style={tdPaddingStyle}>
                            {Number(
                              getCapacityByUserAndMonth(user, month)/60
                            )?.toFixed(2) || "0.00"}
                          </td>
                        ))}
                        <td style={tdPaddingStyle}>
                          {Number(calculateTotalCapacity(user)/60)?.toFixed(2) ||
                            "0.00"}
                        </td>
                        <td style={tdPaddingStyle}>
                          {Number(getYTDForUser(user))?.toFixed(2)|| "0.00"}
                        </td>
                        <td style={tdPaddingStyle}>
                          {Number(getYTDForUser(user)) > 0
                            ? (
                                (Number(calculateTotalCapacity(user)) /
                                  Number(getYTDForUser(user))) *
                                100/60
                              ).toFixed(0)
                            : "0"}
                          %
                        </td>
                        <td style={tdPaddingStyle}>
                          {Number(getMTDForUser(user)/60)?.toFixed(2) || "0.00"}
                        </td>
                        <td style={tdPaddingStyle}>
                          {Number(getBudgetedMtdForUser(user))?.toFixed(2)||
                            "0.00"}
                        </td>
                        <td style={tdPaddingStyle}>
  {Number(getBudgetedMtdForUser(user)) > 0
    ? (((Number(getMTDForUser(user)) / Number(getBudgetedMtdForUser(user))) * 100) / 60).toFixed(0)
    : "0"}
  %
</td>

                        {nextSixMonths.map((month) => (
  <td key={month} style={tdPaddingStyle}>
    {(getForecastMtdForUser(user, month) ?? 0).toFixed(2)}
  </td>
))}


                      </tr>
                    );
                  })}
                <tr
                  style={{
                    ...trStyle,
                    backgroundColor: "#50145a",
                    fontWeight: "700",
                    color: "white",
                  }}
                >
                  <td style={tdPaddingStyle}>Total</td>
                  <td style={tdPaddingStyle}></td>
                  {Array.from({ length: 12 }, (_, month) => month + 1).map(
                    (month) => {
                      const total = usersList
                        .filter(
                          (user) => Number(user.STM_Subteam) === subteam.id
                        )
                        .reduce(
                          (sum, user) =>
                            sum +
                              Number(getCapacityByUserAndMonth(user, month)) ||
                            0,
                          0
                        );

                      return (
                        <td key={month} style={tdPaddingStyle}>
                          {(total/60).toFixed(2)||0}
                        </td>
                      );
                    }
                  )}
                  <td style={tdPaddingStyle}>
                    {usersList
                      .filter((user) => Number(user.STM_Subteam) === subteam.id)
                      .reduce(
                        (sum, user) =>
                          sum + Number(calculateTotalCapacity(user))/60 || 0,
                        0
                      )
                      .toFixed(2)}
                  </td>
                  <td style={tdPaddingStyle}>
                    {usersList
                      .filter((user) => Number(user.STM_Subteam) === subteam.id)
                      .reduce(
                        (sum, user) => sum + Number(getYTDForUser(user)) || 0,
                        0
                      )
                      .toFixed(2)}
                  </td>
                  <td style={tdPaddingStyle}>
                    {(() => {
                      const totalBudgetedYTD = usersList
                        .filter(
                          (user) => Number(user.STM_Subteam) === subteam.id
                        )
                        .reduce(
                          (sum, user) =>
                            sum + Number(getYTDForUser(user)) || 0,
                          0
                        );
                      const totalActualYTD = usersList
                        .filter(
                          (user) => Number(user.STM_Subteam) === subteam.id
                        )
                        .reduce(
                          (sum, user) =>
                            sum + Number(calculateTotalCapacity(user)) || 0,
                          0
                        );

                      return totalBudgetedYTD > 0
                        ? (((totalActualYTD / totalBudgetedYTD) * 100) / 60).toFixed(0)
                        : "0";
                    })()}
                    %
                  </td>
                  <td style={tdPaddingStyle}>
                    {usersList
                      .filter((user) => Number(user.STM_Subteam) === subteam.id)
                      .reduce(
                        (sum, user) => sum + Number(getMTDForUser(user))/60 || 0,
                        0
                      )
                      .toFixed(2)}
                  </td>
                  <td style={tdPaddingStyle}>
                    {usersList
                      .filter((user) => Number(user.STM_Subteam) === subteam.id)
                      .reduce(
                        (sum, user) =>
                          sum + Number(getBudgetedMtdForUser(user))|| 0,
                        0
                      )
                      .toFixed(2)}
                  </td>
                  <td style={tdPaddingStyle}>
                    {(() => {
                      const totalBudgetedMTD = usersList
                        .filter(
                          (user) => Number(user.STM_Subteam) === subteam.id
                        )
                        .reduce(
                          (sum, user) =>
                            sum + Number(getBudgetedMtdForUser(user)) || 0,
                          0
                        );
                      const totalMTD = usersList
                        .filter(
                          (user) => Number(user.STM_Subteam) === subteam.id
                        )
                        .reduce(
                          (sum, user) => sum + Number(getMTDForUser(user)) || 0,
                          0
                        );

                      return totalBudgetedMTD > 0
                        ? (((totalMTD / totalBudgetedMTD) * 100)/60).toFixed(0)
                        : "0";
                    })()}
                    %
                  </td>
                  {nextSixMonths.map((month) => (
  <td key={month} style={tdPaddingStyle}>
    {Number(
      usersList
        .filter((user) => Number(user.STM_Subteam) === subteam.id)
        .reduce(
          (sum, user) => sum + Number(getForecastMtdForUser(user, month)) || 0,
          0
        ) 
    ).toFixed(2)}
  </td>
))}

                </tr>
              </tbody>
            </table>
            </div>
          </>
        ))}
          </div>)
          }
        </div>
       
      </div>
    </div>
  );
};
export default Capacity2;
